import { columns } from "../../../../dtos/columns";
import Conversiones from "../../../../utils/conversiones";
import { ResultOperacionEndoso } from "../models/resultOperacionEndoso";

export function useColumnsResultOperacion(){
    const COLUMNS_RESULT: columns<ResultOperacionEndoso>[] = [
        {
            name: 'N° operación',
            selector: (row: ResultOperacionEndoso) => row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Tasa endoso',
            selector: (row: ResultOperacionEndoso) => row.tasaEndoso,
            sortable: true,
            sortField: 'tasaEndoso',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'N° cupones cortados',
            selector: (row: ResultOperacionEndoso) => row.numeroCupones,
            sortable: true,
            sortField: 'numeroCupones',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: "Fecha a remesar",
            selector: (row: ResultOperacionEndoso) => Conversiones.fechaCortaFormat((row.fechaRemesa ?? "").toString()),
            sortable: true,
            sortField: 'fechaRemesa',
            wrap: true,
            export: true,
            alling: 'left',
        },
        {
            name: 'Observación',
            selector: (row: ResultOperacionEndoso) => row.observacion,
            sortable: true,
            sortField: 'observacion',
            wrap: true,
            alling: 'left',
            export: true,
        },
    ]

    return {COLUMNS_RESULT}
}